import { captureException } from '@sentry/react';
import { isAxiosError } from 'axios';
import { monitoring } from 'common/services';
import { addAppAlertDialog, addAppBackendErrorMessage, addAppErrorMessage } from 'modules/alerts/state';
import { isApiErrors, isApiResponse } from 'modules/api/utils';

import type { Dispatch } from '@reduxjs/toolkit';

// TODO refactor args to single object
export function handleQueryError(
  error: unknown,
  dispatch: Dispatch,
  metadata: string,
  message: string,
  showAlertDialog = false
) {
  captureException(error, {
    tags: {
      metadata,
      message,
    },
  });

  // Named after the failed action, so Error Tracking groups failures by it: for a rejected RTK Query action,
  // one issue per API slice. Only the status goes with it, as the response body can quote the user's own data
  // and some listeners pass that body as `message`. Error Tracking ignores numbers when it groups messages, so
  // the status belongs in context.
  monitoring.reportError(new Error(`Query failed: ${metadata}`), {
    metadata,
    status: isApiResponse(error) ? error.status : undefined,
  });

  if (showAlertDialog) {
    dispatch(
      addAppAlertDialog({
        title: message,
        description: '',
        severity: 'danger',
      })
    );
  } else if (isApiResponse(error) && isAxiosError(error.data) && error.status === 500) {
    dispatch(addAppBackendErrorMessage('Unknown server error'));
  } else if (isApiResponse(error) && isApiErrors(error.data)) {
    error.data.errors.forEach(({ message: apiErrorMessage }) => {
      dispatch(addAppErrorMessage(apiErrorMessage));
    });
  } else {
    dispatch(addAppErrorMessage(message));
  }
}
